export default "__VITE_ASSET__DL1CZR_F__"